import { Injectable } from '@angular/core';

import { Job } from '../../Domain/Model/CreateJob/create-job.model';
import { EstimateJobRequest } from '../../Domain/Port/EstimateJob/estimate-job-request.model';

@Injectable({
    providedIn: 'root'
})
export class EstimateJobRequestFactoryService {
    createFromCreateJob(createJob: Job): EstimateJobRequest {
        return new EstimateJobRequest(createJob.type, createJob.date.startDate, createJob.guards.hoursGuardPerDay);
    }
}
